/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
const apiEndpoint = process.env.REACT_APP_API

function loadHeatmap(teamName, gameId, traceNumber) {
    return (dispatch, getState) => {
        
        let heatmapState = getState().heatmap
        if ((heatmapState.complete && heatmapState.value.teamName === teamName && heatmapState.value.gameId === gameId && heatmapState.value.traceNumber === traceNumber) || heatmapState.loading) {
            return { type: 'NOOP' }
        }

        dispatch({
            type: 'COMMON_SET',
            key: 'heatmap',
            value: {
                complete: false,
                loading: true,
                value: null,
                error: null
            }
        })

        var url = `${apiEndpoint}/teams/${teamName}/games/${teamName}-${gameId}/p${traceNumber}-heatmaps.json`
        return fetch(url)
            .then(response => response.json())
            .then(map => {
                dispatch({
                    type: 'COMMON_SET',
                    key: 'heatmap',
                    value: {
                        complete: true,
                        loading: false,
                        value: {
                            teamName,
                            gameId,
                            traceNumber,
                            map,
                        },
                        error: null,
                    }
                })
            })
            .catch(err => {
                console.error('FetchHeatmaps ERROR', err)
                dispatch({
                    type: 'COMMON_SET',
                    key: 'heatmap',
                    value: {
                        complete: true,
                        loading: false,
                        value: {
                            teamName,
                            gameId,
                            traceNumber,
                            map: {},
                        },
                        error: err,
                    }
                })
            })

    }
}


export default loadHeatmap
